"use client";
import { SectionAuthorPromo } from "@/components/pages/authors/SectionAuthorPromo";
import { AuthorArticles } from "@/components/pages/authors/AuthorArticles";
import { AuthorSinglePageContext } from "@/helpers/contexts/AuthorSinglePageContext";
import { AuthorSinglePageProps } from "@/types/strapi/author";
import { getBioContent } from "@/components/pages/authors/getBioContent";
import { Page } from "@/components/layout/Layout";
import { PageGradientWrapper } from "@/components/layout/PageGradientWrapper";
import { baseUrl } from "@/const";

export const AuthorPage = (props: AuthorSinglePageProps) => (
  <Page
    headerColor="black"
    {...props.author.meta}
    isBlogPage
    pageType="Person"
    authorData={{
      name: props.author.fullName,
      image: props.author.avatar.url,
      disambiguatingDescription: props.author.bio ? getBioContent(props.author.bio) : undefined,
    }}
    extraStructuredDataFields={{
      potentialAction: {
        "@type": "SearchAction",
        target: `https://${baseUrl}/authors/${props.author.slug}?search={s}`,
        "query-input": {
          "@type": "PropertyValueSpecification",
          valueRequired: true,
          valueMinlength: 3,
          valueMaxlength: 100,
          valueName: "s",
        },
      },
    }}
  >
    <PageGradientWrapper>
      <AuthorSinglePageContext.Provider value={props}>
        <SectionAuthorPromo />

        <AuthorArticles />
      </AuthorSinglePageContext.Provider>
    </PageGradientWrapper>
  </Page>
);
